module.exports = {"Retirement3":{"daobanList":[{"title":"1:您是否已在其他地区领取企业职工养老保险待遇，或已领取机关养老保险、居民养老保险或其他险种领取养老待遇？（单选）","values":[{"name":"是","xuanzhong":1,"cailiaoList":[{"name":"1、企业职工基本养老保险待遇申报表","state":"必要"},{"name":"2、退休时间申请书","state":"必要"},{"name":"3、居民身份证","state":"必要"},{"name":"4、参保人的社会保障卡","state":"必要"}]},{"name":"否","xuanzhong":0,"cailiaoList":[{}]}]}]}}


//////////////////
// WEBPACK FOOTER
// ./static/js/situation/sdr-3.json
// module id = 1293
// module chunks = 0